<div id="id{{ name }}" class="main {{ userClass }}" (click)="inside()">
  <div
    [class.haserror-gotop]="isshow && f[name].touched && f[name]?.invalid"
    [class.gotop]="isshow"
    (focus)="focusFunction()"
    (click)="focusFunction(); inp.click()"
    (focusout)="focusOutFunction()"
    class="label">
    <label class="txt" [class.lbl]="isshow"> {{ label }} </label>
    <span class="star" [class.error]="f[name].touched && f[name]?.invalid" *ngIf="required === true"> * </span>
  </div>
  <div class="inputbox" id="inputbox{{ name }}" [class.hasborder]="isshow">
    <input
      #inp
      type="text"
      [(ngModel)]="currentValue"
      (focus)="focusFunction()"
      (focusout)="focusOutFunction()"
      class="textinput"
      [class.border]="isshow"
      [class.hasborder]="isshow"
      [(ngClass)]="class"
      id="{{ name }}"
      name="{{ name }}"
      [disabled]="disabled"
      autocomplete="off"
      (keyup)="onkeyup($event.target.value)" />
    <span
      *ngIf="showClear()"
      class="ng-clear-wrapper"
      [title]="'ClientApp.Projects.FrameWorkShell.Shared.Controls.LookUpTree.Delete' | translate"
      (click)="clearValue()">
      <span class="ng-clear" aria-hidden="true">×</span>
    </span>

    <span class="ng-arrow-wrapper" (click)="openPopover()">
      <span class="ng-arrow"></span>
    </span>
  </div>

  <div *ngIf="f[name].errors && (f[name].dirty || f[name].touched)" class="alert alert-danger">
    <div [hidden]="!f[name].errors.required">{{ label }} {{ "ClientApp.Projects.FrameWorkShell.Shared.Controls.LookUpTree.Delete" | translate }}</div>
    <div [hidden]="!f[name].errors.minlength">
      {{ label }} {{ "ClientApp.Projects.FrameWorkShell.LookUpTree.MustMoreThan" | translate }} {{ minLength }}
      {{ "ClientApp.Projects.FrameWorkShell.Shared.Controls.LookUpTree.BeCharacter" | translate }}
    </div>
    <div [hidden]="!f[name].errors.maxlength">
      {{ label }} {{ "ClientApp.Projects.FrameWorkShell.Shared.Controls.LookUpTree.Over" | translate }} {{ maxLength }}
      {{ "ClientApp.Projects.FrameWorkShell.Shared.Controls.LookUpTree.CharacterCanNotBe" | translate }}
    </div>
  </div>
  <!-- <validation [@flyInOut]="'in,out'"
              *ngIf="invalid | async"
              [messages]="failures | async">
  </validation> -->
</div>

<ssg-popover *ngIf="openToggle" (outsideClick)="closeout()" hasRefresh="true" #ngdropdownpanel id="sdsadsds">
  <div #template *ngIf="openToggle" [id]="name">
    <kendo-treeview
      *ngIf="hasCheckBoxLookUpTree; else otherTemp"
      [nodes]="filterdList"
      [children]="children"
      [hasChildren]="hasChildren"
      textField="{{ textFieldName }}"
      kendoTreeViewExpandable
      [kendoTreeViewCheckable]="checkableSettings"
      kendoTreeViewFlatDataBinding
      kendoTreeViewSelectable
      parentIdField="{{ parentIdName }}"
      idField="{{ valueFieldName }}"
      [(checkedKeys)]="_checkedKeys"
      [checkBy]="valueFieldName"
      (selectionChange)="handleSelection($event)">
    </kendo-treeview>
  </div>
  <ng-template #otherTemp>
    <kendo-treeview
      [nodes]="filterdList"
      [children]="children"
      [hasChildren]="hasChildren"
      textField="{{ textFieldName }}"
      kendoTreeViewExpandable
      kendoTreeViewFlatDataBinding
      kendoTreeViewSelectable
      parentIdField="{{ parentIdName }}"
      idField="{{ valueFieldName }}"
      (selectionChange)="handleSelection($event)">
    </kendo-treeview>
  </ng-template>
</ssg-popover>
